import React, { useState, useCallback, useEffect } from 'react';
import { getENSDetails } from '../../../api/GBENSDec';
import dayjs from 'dayjs';

const useData = (state, setHeaderId, setCompanyId, setToRunInitialErrorCheck) => {
  const [data, setData] = useState({
    TransportAndJourney: {
      ENSRequestor: {
        country: '',
        EORI: '',
        companyName: '',
        streetAddress: '',
        townCity: '',
        postcode: '',
      },
      Route: {
        destinationCountry: 80,
      },
    },
    Consignments: [],
    AdditionalDetails: {
      TransportDocuments: {
        rows: [],
      },
      NotifyParties: {
        rows: [],
      },
    },
    initialLoad: true,
  });

  const updateData = useCallback(
    (e, screen, field, modal) => {
      //this fixes the text drag-and-drop issue we're having in the datetime picker
      if (!e || !screen) {
        return;
      }
      if (!screen) throw new Error('Screen is required');
      const value = e.$isDayjsObject ? e : e.target.value;
      if (!modal) {
        if (!data[screen]) setData((prev) => ({ ...prev, [screen]: { [field]: value } }));
        else setData((prev) => ({ ...prev, [screen]: { ...prev[screen], [field]: value } }));
      } else if (!data[screen]) {
        setData((prev) => ({ ...prev, [screen]: { [modal]: { [field]: value } } }));
      } else if (!data[screen][modal])
        setData((prev) => ({ ...prev, [screen]: { ...prev[screen], [modal]: { [field]: value } } }));
      else
        setData((prev) => ({
          ...prev,
          [screen]: { ...prev[screen], [modal]: { ...prev[screen][modal], [field]: value } },
        }));
    },
    [data]
  );

  const moveData = useCallback(
    (screen, modalFrom, modalTo, deleteModalFrom) => {
      if (!deleteModalFrom)
        setData((prev) => ({
          ...prev,
          [screen]: {
            ...prev[screen],
            [modalTo]: prev?.[screen]?.[modalFrom] ? JSON.parse(JSON.stringify(prev[screen][modalFrom])) : {},
          },
        }));
      else
        setData((prev) => ({
          ...prev,
          [screen]: {
            ...prev[screen],
            [modalTo]: prev?.[screen]?.[modalFrom] ? JSON.parse(JSON.stringify(prev[screen][modalFrom])) : {},
            [modalFrom]: undefined,
          },
        }));
    },
    [data]
  );

  const deleteData = useCallback(
    (screen, modal) => {
      setData((prev) => ({ ...prev, [screen]: { ...prev[screen], [modal]: undefined } }));
    },
    [data]
  );

  useEffect(() => {
    if (state?.companyId) {
      setCompanyId(state.companyId);
      //update the data.TransportAndJourney.ENSRequestor with the information from state.currentCompany
      data.TransportAndJourney.ENSRequestor = {
        country: state?.currentCompany?.country || '',
        EORI: state?.currentCompany?.companyEori || '',
        companyName: state?.currentCompany?.companyName || '',
        streetAddress: state?.currentCompany?.streetAddress || '',
        townCity: state?.currentCompany?.townCity || '',
        postcode: state?.currentCompany?.postcode || '',
      };
    }
  }, [state]);

  useEffect(() => {
    const fetch = async () => {
      setHeaderId(state.headerId);
      const dt = await getENSDetails(state.headerId);
      if (dt.TransportAndJourney.arrivalDateTime)
        dt.TransportAndJourney.arrivalDateTime = dayjs(dt.TransportAndJourney.arrivalDateTime);
      if (dt.TransportAndJourney.departureDate)
        dt.TransportAndJourney.departureDate = dayjs(dt.TransportAndJourney.departureDate);
      dt.TransportAndJourney.Route = { ...dt.TransportAndJourney.Route, destinationCountry: 80 };
      if (dt.Consignments === null) dt.Consignments = [];
      dt.Consignments = dt.Consignments.map((c) => {
        if (!c.lines) c.lines = [];
        if (!c.Consignee) c.Consignee = {};
        if (!c.Consignor) c.Consignor = {};
        return c;
      });
      if (dt.AdditionalDetails?.TransportDocuments?.rows === undefined)
        dt.AdditionalDetails.TransportDocuments = { rows: [] };
      if (dt.AdditionalDetails?.NotifyParties?.rows === undefined) dt.AdditionalDetails.NotifyParties = { rows: [] };
      setData(dt);
      setToRunInitialErrorCheck(true);
    };
    if (state?.headerId) {
      fetch();
    }
  }, [state]);

  return { data, setData, updateData, moveData, deleteData };
};

export default useData;
